import { isDev } from "../util";
import local from "./local";
import sentry from "./sentry";
export default isDev ? local.Logger : sentry.Logger;
